<template>
  <v-card flat>
    <v-card-title class="d-flex align-center pe-2">
      <v-icon icon="mdi-eye-refresh"></v-icon> &nbsp;
      Dashboard
      <v-spacer></v-spacer>

      <v-text-field v-model="search" density="compact" label="Search" prepend-inner-icon="mdi-magnify"
        variant="solo-filled" flat hide-details single-line></v-text-field>
    </v-card-title>

    <v-divider></v-divider>

    <v-table fixed-header>
      <thead>
        <tr>
          <th>
            Connection
          </th>
          <th class="text-left">
            Name
          </th>
          <th class="text-left">
            Machine
          </th>
          <th class="text-left">
            RMS
          </th>
          <th class="text-left">
            RMS Stream
          </th>
          <th class="text-left">
            RMS Mould
          </th>
          <th class="text-left">
            CIM
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in filteredData" :key="item.name">
          <td>
            <v-chip class="mr-2" variant="elevated"
              :color="(({ '1': 'green', '0': 'default' })[item.ewon_status] ?? 'orange')">
              {{ (({ "1": "Online", "0": "Offline" })[item.ewon_status] ?? "Awaiting") }}
            </v-chip>
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.machine }}</td>
          <td>
            <template v-if="item.rms_active">
              <v-chip class="mr-2" variant="elevated"
                :color="(({ '1': 'green', '0': 'red' })[item.rms_status] ?? 'orange')">
                {{ (({ "1": "OK", "0": "Offline" })[item.rms_status] ?? "Awaiting") }}
              </v-chip>
            </template>
          </td>

          <td>
            <span>
              {{ item.rms_latest_stream_diff_sec }}
              <v-tooltip activator="parent" location="bottom">{{ item.rms_latest_stream_diff_sec }} days since latest
                stream
                recording<br>{{ item.rms_latest_stream }} UTC</v-tooltip>
            </span>
          </td>
          <td>
            <span>
              {{ item.rms_latest_mould_diff_sec }}
              <v-tooltip activator="parent" location="bottom">{{ item.rms_latest_mould_diff_sec }} days since latest
                mould
                recording<br>{{ item.rms_latest_mould }} UTC</v-tooltip>
            </span>
          </td>

          <td>
            <template v-if="item.cim_active == 1">
              <template v-if="item.cim_module_status == 0 || item.cim_module_status == null">
                <v-chip class="mr-2" variant="elevated"
                  :color="(({ '1': 'green', '0': 'default' })[item.cim_status] ?? 'orange')">
                  {{ (({ "1": "OK", "0": "Offline" })[item.cim_status] ?? "Awaiting") }}
                </v-chip>
              </template>
              <template v-else-if="item.cim_status == -1">
                <v-chip class="mr-2" variant="elevated" color="orange">
                  Awaiting
                </v-chip>
              </template>
              <template v-else>
                <v-chip class="mr-2" variant="elevated" color="yellow">
                  Warning
                </v-chip>
              </template>
            </template>
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-card>
</template>

<script>

import { useDashboardStore } from '@/stores/dashboard'

export default {
  data() {
    return {
      dashboard: useDashboardStore(),
      search: ''
    }
  },
  computed: {
    filteredData() {
      if (!this.search) {
        return this.dashboard.data.data; // Return all data if search is empty
      }

      const searchLower = this.search.toLowerCase();
      console.log(this.dashboard.data.data)
      return this.dashboard.data.data.filter(item =>
        item.name.toLowerCase().includes(searchLower) ||
        item.machine.toLowerCase().includes(searchLower) ||
        String(item.ewon_status).toLowerCase().includes(searchLower)
      );
    }
  }
}
</script>